import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { DsDialogInstance } from '@skyeng/libs/shared/ui-kit-v2/dialog';
import { TranslocoService } from '@ngneat/transloco';
import { registerTranslationsManuallyStatic } from '@skyeng/libs/shared/i18n';
import entranslation from './translation/en.json';
import rutranslation from './translation/ru.json';

@Component({
  selector: 'skypro-reset-dialog',
  templateUrl: './reset-dialog.component.html',
  styleUrls: ['./reset-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ResetDialogComponent {
  private dsDialogInstance = inject(DsDialogInstance<void, void>);
  private translocoService = inject(TranslocoService);

  constructor() {
    registerTranslationsManuallyStatic('skyproLibsBlocksPythonResetDialog', this.translocoService, {
      en: entranslation,
      ru: rutranslation,
    });
  }

  confirm(): void {
    this.close(false);
  }

  cancel(): void {
    this.close(true);
  }

  private close(rejected: boolean): void {
    this.dsDialogInstance.close({ rejected });
  }
}
